import React from 'react';
import { INavbar } from './Navbar/Navbar';

export interface IItemProps extends INavbar {
  component: React.ReactNode;
}

const Item = (props: IItemProps) => <></>;
export default Item;
